import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Navigate } from "react-router-dom";

import { Card, Grid, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import MediaPickerModal from "Main/Modals/MediaModal";

export default class UpdatePopup extends Component {
  state = {
    id: "",
    title: "",
    selectedImage: null,
    showMediaModal: false,

    message: "",
    notification: false,
    noticolor: "success",
    loading: false,
    redirect: false,
  };

  componentDidMount() {
    this.getSinglePopup();
  }

  // ✅ FETCH SINGLE POPUP
  getSinglePopup = async () => {
    const id = window.location.pathname.split("/")[2];

    try {
      const resp = await axios.post(
        Constants.getUrls.getPopupDetails,
        { id }
      );

      if (resp.data.status) {
        const data = resp.data.data;

        this.setState({
          id,
          title: data.title || "",
          selectedImage: data.image_id
            ? {
                id: data.image_id,
                image_path: data.image_path,
              }
            : null,
        });
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: "Failed to fetch popup",
        noticolor: "warning",
      });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // ✅ UPDATE POPUP
  handleSubmit = async (e) => {
    e.preventDefault();

    const { id, title, selectedImage } = this.state;

    if (!title || !selectedImage) {
      return this.setState({
        notification: true,
        message: "All fields are required!",
        noticolor: "warning",
      });
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const payload = {
      id,
      title,
      image_id: selectedImage.id,
      role_id: 1, // ✅ fixed
    };

    this.setState({ loading: true });

    try {
      const resp = await axios.post(
        Constants.putUrls.updatePopup,
        payload
      );

      this.setState({
        notification: true,
        message: resp.data.message || "Updated successfully!",
        noticolor: "success",
        loading: false,
      });

      setTimeout(() => {
        this.setState({ redirect: true });
      }, 1500);
    } catch (err) {
      this.setState({
        notification: true,
        message:
          err?.response?.data?.message || "Something went wrong!",
        noticolor: "warning",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/popups" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card style={{ padding: 20 }}>

            {/* 🔥 HEADER */}
            <MDBox
              mx={2}
              mt={-6}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Update Popup
              </MDTypography>
            </MDBox>

            <form onSubmit={this.handleSubmit}>
              <Grid container spacing={2} mt={1}>

                {/* TITLE */}
                <Grid item sm={12}>
                  <TextField
                    label="Title"
                    name="title"
                    value={this.state.title}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                {/* IMAGE */}
                <Grid item sm={6}>
                  <MDButton
                    variant="contained"
                    onClick={() =>
                      this.setState({ showMediaModal: true })
                    }
                  >
                    Change Image
                  </MDButton>

                  {this.state.selectedImage && (
                    <img
                      src={
                        Constants.imageDomain +
                        this.state.selectedImage.image_path
                      }
                      style={{
                        width: 80,
                        height: 80,
                        marginTop: 10,
                        borderRadius: 6,
                      }}
                    />
                  )}
                </Grid>

                {/* SUBMIT */}
                <Grid item sm={12}>
                  <MDButton type="submit" variant="contained" color="info">
                    {this.state.loading ? "Updating..." : "Update"}
                  </MDButton>
                </Grid>

              </Grid>
            </form>

          </Card>

          <MDSnackbar
            color={this.state.noticolor}
            title="Popup"
            content={this.state.message}
            open={this.state.notification}
          />

          {/* MEDIA MODAL */}
          <MediaPickerModal
            visible={this.state.showMediaModal}
            multiple={false}
            onClose={() =>
              this.setState({ showMediaModal: false })
            }
            onSelect={(images) => {
              this.setState({
                selectedImage: images[0],
                showMediaModal: false,
              });
            }}
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}